// extracted by mini-css-extract-plugin
export default {"menu":"UserMenu_menu__6jfJY"};